"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StartOver = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _constants = require("../constants");

var _conversation = require("../store/actions/conversation");

var _app = require("../store/reducers/app");

var _conversation2 = require("../store/reducers/conversation");

var _app2 = require("../store/selectors/app");

var _traffic = require("../store/actions/traffic");

var _conversation3 = require("../store/selectors/conversation");

var _styles = _interopRequireDefault(require("../styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var StartOver =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(StartOver, _PureComponent);

  function StartOver(props) {
    var _this;

    _classCallCheck(this, StartOver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StartOver).call(this, props));
    _this.handleEndChatOrStartOver = _this.handleEndChatOrStartOver.bind(_assertThisInitialized(_this));
    _this.state = {
      endChatConfirmed: false
    };
    return _this;
  }

  _createClass(StartOver, [{
    key: "handleEndChatOrStartOver",
    value: function handleEndChatOrStartOver() {
      var _this2 = this;

      var _this$props = this.props,
          appContext = _this$props.appContext,
          conversationProcessing = _this$props.conversationProcessing;
      var endChatConfirmed = this.state.endChatConfirmed;

      if (appContext === _constants.CONTEXT_LIVE_ENGAGE) {
        if (endChatConfirmed) {
          this.props.conversationSend(_constants.SLASH_COMMAND_CHAT_END);
          this.props.trafficEndChatClick();
        } else {
          this.setState({
            endChatConfirmed: true
          }, function () {
            setTimeout(function () {
              _this2.setState({
                endChatConfirmed: false
              });
            }, 3000);
          });
        }
      } else if (!conversationProcessing) {
        this.props.conversationClear();
        this.props.conversationInitialize();
        this.props.trafficChatResetClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appContext = _this$props2.appContext,
          conversationProcessing = _this$props2.conversationProcessing,
          conversationUtterances = _this$props2.conversationUtterances;
      var endChatConfirmed = this.state.endChatConfirmed;
      return conversationUtterances.length ? _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("button", {
        disabled: conversationProcessing,
        onClick: this.handleEndChatOrStartOver,
        className: _style["default"].dynamic([["3719155976", [_styles["default"].colors.grayLight, _styles["default"].colors.blue, _styles["default"].colors.grayLight]]]) + " " + 'chatbot-reset-button'
      }, appContext === _constants.CONTEXT_LIVE_ENGAGE // eslint-disable-line no-nested-ternary
      ? endChatConfirmed ? 'Are you sure?' : 'End chat' : 'Start over'), _react["default"].createElement(_style["default"], {
        id: "3719155976",
        dynamic: [_styles["default"].colors.grayLight, _styles["default"].colors.blue, _styles["default"].colors.grayLight]
      }, ".chatbot-reset-button.__jsx-style-dynamic-selector{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:none;border-bottom:1px solid ".concat(_styles["default"].colors.grayLight, ";color:").concat(_styles["default"].colors.blue, ";cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;font-size:14px;font-weight:bold;height:35px;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;left:0;min-width:105px;padding:0 20px;top:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;}.chatbot-reset-button.__jsx-style-dynamic-selector:disabled{color:").concat(_styles["default"].colors.grayLight, ";cursor:not-allowed;}.chatbot-reset-button.__jsx-style-dynamic-selector:focus{outline:none;}.chatbot-reset-button.__jsx-style-dynamic-selector:hover{box-shadow:rgba(0,0,0,0.15) 0px 0px 10px;}"))) : null;
    }
  }]);

  return StartOver;
}(_react.PureComponent);

exports.StartOver = StartOver;
StartOver.propTypes = {
  appContext: _app.appPropTypes.context,
  conversationClear: _propTypes["default"].func.isRequired,
  conversationInitialize: _propTypes["default"].func.isRequired,
  conversationProcessing: _conversation2.conversationPropTypes.processing,
  conversationUtterances: _propTypes["default"].array.isRequired,
  conversationSend: _propTypes["default"].func.isRequired,
  trafficEndChatClick: _propTypes["default"].func.isRequired,
  trafficChatResetClick: _propTypes["default"].func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appContext: (0, _app2.getAppContext)(state),
    conversationProcessing: (0, _conversation3.getConversationProcessing)(state),
    conversationUtterances: (0, _conversation3.getConversationUtterances)(state)
  };
};

var mapDispatchToProps = {
  conversationClear: _conversation.conversationClear,
  conversationInitialize: _conversation.conversationInitialize,
  conversationSend: _conversation.conversationSend,
  trafficEndChatClick: _traffic.trafficEndChatClick,
  trafficChatResetClick: _traffic.trafficChatResetClick
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StartOver);

exports["default"] = _default;